export default "__VITE_ASSET__B$dw7$X7__"